import { createGlobalStyle } from 'styled-components';
import gameboyWoff from './game_boy_1989.woff';
import minecraftiaWoff2 from './Minecraftia-Regular.woff2';
import minecraftiaWoff from './Minecraftia-Regular.woff';
import DogicaWoff2 from './Dogica.woff2';
import DogicaWoff from './Dogica.woff';

export default createGlobalStyle`
    @font-face {
      font-family: 'Game Boy 1989 Regular';
      src: url(${gameboyWoff}) format('woff');
    }

    @font-face {
      font-family: 'Minecraftia';
      src: url(${minecraftiaWoff2}) format('woff2'),
          url(${minecraftiaWoff}) format('woff');
    }

    @font-face {
    font-family: 'Dogica';
    src: url(${DogicaWoff2}) format('woff2'),
        url(${DogicaWoff}) format('woff');
    }
  `;
